import Seo from "@/lib/Seo";
import PageHero from "@/components/common/PageHero";
import SectionHeading from "@/components/common/SectionHeading";
import FormationCard from "@/components/common/FormationCard";
import { CATEGORIES, getFormationsByCategory } from "@/data/formations";

export default function FormationsIndex() {
  return (
    <>
      <Seo
        title="Nos formations transport"
        description="Découvrez toutes les formations EDUCASER GROUP : transport de marchandises, transport de voyageurs et formations d'enseignants de la conduite. Permis, FIMO, FCO et titres professionnels."
        path="/nos-formations"
      />
      <PageHero
        breadcrumb={[{ label: "Accueil", to: "/" }, { label: "Nos formations" }]}
        eyebrow="Catalogue de formations"
        title="Nos formations"
        intro="Un catalogue complet de formations certifiantes pour les métiers du transport et de l'enseignement de la conduite."
      />

      <div className="bg-white py-20 lg:py-28">
        <div className="mx-auto max-w-7xl space-y-24 px-5 lg:px-8">
          {CATEGORIES.map((cat) => (
            <div key={cat.slug} id={cat.slug}>
              <SectionHeading eyebrow={`${getFormationsByCategory(cat.slug).length} formations`} title={cat.title} intro={cat.baseline} />
              <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {getFormationsByCategory(cat.slug).map((f, i) => (
                  <FormationCard key={f.slug} formation={f} categorySlug={cat.slug} index={i} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
